import { render, staticRenderFns } from "./ResetPasswordSSNView.vue?vue&type=template&id=5a38c8eb&scoped=true&"
import script from "./ResetPasswordSSNView.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordSSNView.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordSSNView.vue?vue&type=style&index=0&id=5a38c8eb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a38c8eb",
  null
  
)

export default component.exports